import { Routes } from '@angular/router';
import { HostThisToolComponent } from './host-this-tool/host-this-tool.component';
import { LandingComponent } from './landing/landing.component';

export const routes: Routes = [
  {
    path: '',
    component: LandingComponent,
  },
  {
    path: 'search-results',
    loadChildren: () =>
      import('./search-results/search-results.routing').then((m) => m.routes),
  },
  {
    path: 'host-this-tool',
    component: HostThisToolComponent,
  },
  {
    path: '**',
    redirectTo: '',
  },
];
